import { reviewsFiles_files } from '../__generated__/reviewsFiles'
import { IMediaElement } from '../components/types'

export default function createMediaElements(
  files: reviewsFiles_files[],
): IMediaElement[] {
  if (!files.length) return []

  const mediaElements: IMediaElement[] = []

  files.forEach((file) => {
    const contentType = file.contentType.split('/')[0]
    const type =
      contentType === 'application' || contentType === 'image' ? 'img' : 'video'

    const src = type === 'img' ? file.url : file.videoCover?.url

    if (src) {
      mediaElements.push({
        id: file.id,
        reviewId: file.PropertyRelationTargetFiles[0].element.id,
        type,
        src,
      })
    }
  })

  return mediaElements
}
